(function(){
  var cache = {};
  var ARROW_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><path d="M12 12v4M10 14h4"/></svg>';
  var CAN_HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);
  function handleOf(card){
    var a = card.querySelector('a[href*="/products/"]');
    if(!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? {h: m[1], href: a.href} : null;
  }
  function load(h){
    if(!cache[h]) cache[h] = fetch('/products/' + h + '.js').then(function(r){ return r.json(); });
    return cache[h];
  }
  function sized(u){ if(u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=720'; }
  function mk(cls, html, label){
    var b = document.createElement('button');
    b.type = 'button'; b.className = cls; b.innerHTML = html; b.setAttribute('aria-label', label);
    return b;
  }
  function btn(cls, html, label){ return mk('b2b-btn ' + cls, html, label); }
  function setup(card){
    if(card.dataset.b2b) return;
    card.dataset.b2b = '1';
    var info = handleOf(card); if(!info) return;
    var inner = card.querySelector('.card__inner'); if(!inner) return;
    var img = inner.querySelector('.card__media img'); if(!img) return;
    load(info.h).then(function(p){
      var imgs = p.images || [];
      var i = 0;
      var hov = false;
      if(imgs.length > 1){
        var extra = inner.querySelectorAll('.card__media img');
        for(var x = extra.length - 1; x > 0; x--){ extra[x].parentNode.removeChild(extra[x]); }
        var prev = btn('b2b-prev', ARROW_L, 'Previous image');
        var next = btn('b2b-next', ARROW_R, 'Next image');
        var dots = document.createElement('div'); dots.className = 'b2b-dots';
        imgs.slice(0, 8).forEach(function(_, k){ var d = document.createElement('span'); if(k === 0) d.className = 'on'; dots.appendChild(d); });
        var show = function(k){
          img.removeAttribute('srcset'); img.removeAttribute('sizes');
          img.src = sized(imgs[k]);
          Array.prototype.forEach.call(dots.children, function(d, n){ d.className = (n === k % 8) ? 'on' : ''; });
        };
        var go = function(n, e){
          e.preventDefault(); e.stopPropagation();
          if(hov){ i = 1; hov = false; }
          i = (i + n + imgs.length) % imgs.length;
          show(i);
        };
        prev.addEventListener('click', function(e){ go(-1, e); });
        next.addEventListener('click', function(e){ go(1, e); });
        if(CAN_HOVER){
          card.addEventListener('mouseenter', function(){ if(i === 0){ hov = true; show(1); } });
          card.addEventListener('mouseleave', function(){ if(hov){ hov = false; show(0); } });
        }
        inner.appendChild(prev); inner.appendChild(next); inner.appendChild(dots);
      }
      if(window.B2B_LOGGED){
        var c = btn('b2b-cart', BAG, 'Add to cart');
        c.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          if(p.variants.length > 1){ window.location.href = info.href; return; }
          fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: p.variants[0].id, quantity: 1}]})})
            .then(function(r){ return r.json(); })
            .then(function(){
              c.classList.add('done'); setTimeout(function(){ c.classList.remove('done'); }, 1500);
              return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
                var b = document.querySelector('.cart-count-bubble span[aria-hidden="true"]') || document.querySelector('.cart-count-bubble span');
                if(b) b.textContent = cart.item_count;
              });
            });
        });
        inner.appendChild(c);
      }
    }).catch(function(){});
  }
  function gallery(g){
    if(g.dataset.b2bArrows) return;
    var viewer = g.querySelector('[id^="GalleryViewer"]');
    var sel = '.thumbnail-list__item button';
    if(!viewer || g.querySelectorAll(sel).length < 2) return;
    g.dataset.b2bArrows = '1';
    viewer.classList.add('b2b-gallery');
    var move = function(n, e){
      e.preventDefault(); e.stopPropagation();
      var t = g.querySelectorAll(sel); if(!t.length) return;
      var k = 0;
      for(var x = 0; x < t.length; x++){ if(t[x].getAttribute('aria-current') === 'true'){ k = x; break; } }
      t[(k + n + t.length) % t.length].click();
    };
    var prev = mk('b2b-garrow b2b-garrow--prev', ARROW_L, 'Previous image');
    var next = mk('b2b-garrow b2b-garrow--next', ARROW_R, 'Next image');
    prev.addEventListener('click', function(e){ move(-1, e); });
    next.addEventListener('click', function(e){ move(1, e); });
    viewer.appendChild(prev); viewer.appendChild(next);
  }
  function run(){
    document.querySelectorAll('.card-wrapper').forEach(setup);
    document.querySelectorAll('media-gallery').forEach(gallery);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function(){ run(); }).observe(document.documentElement, {childList: true, subtree: true});
})();
